import { createContext } from 'react';

export interface SvgContext {
  width: number;
  height: number;
}

export const svgContext = createContext<SvgContext | null>(null);
